// Admin
const Listadmin = () => import('@/views/admin-management/admin/index')
const Formadmin = () => import('@/views/admin-management/admin/form')

export default {
    path: 'admin',
    redirect: '/admin',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'admin',
            component: Listadmin,
            meta: {
                link: 'admin',
                breadcrumb: [
                    { title: 'Admin Management', active: true },
                    { title: 'Admin', active: true },
                ],
                pageTitle: 'Admin'
            }
        },
        {
            path: 'add',
            name: 'addadmin',
            component: Formadmin,
            meta: {
                link: 'admin',
                breadcrumb: [
                    { title: 'Admin Management', active: true },
                    { title: 'Admin', url: '/admin' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Admin'
            }
        },
        {
            path: 'edit/:id',
            name: 'editadmin',
            component: Formadmin,
            meta: {
                link: 'admin',
                breadcrumb: [
                    { title: 'Admin Management', active: true },
                    { title: 'Admin', url: '/admin' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Admin'
            }
        },
    ]
}